import axios from "axios";
import { observable, runInAction } from "mobx";
import Configuration from "../Configuration";

export interface IClient {
  key: number;
  value: string;
}

class ClientStore {
  @observable public isLoadingClients: boolean = false;
  @observable public clients: IClient[] = [];
  @observable public error: string = "";

  public async getClients(): Promise<void> {
    runInAction(() => {
      this.isLoadingClients = true;
      this.error = "";
    });

    try {
      const result = await axios.get<IClient[]>(
        Configuration.REACT_APP_CLIENT_LIST_ENDPOINT,
        {
          headers: {
            Authorization: Configuration.REACT_APP_HGEM_API_BASIC_AUTH_HEADER,
          },
        },
      );
      runInAction(() => {
        this.clients = result.data;
      });
    } catch (error) {
      runInAction(() => {
        this.error = "An error occurred getting clients";
      });
    } finally {
      runInAction(() => {
        this.isLoadingClients = false;
      });
    }
  }
}

export default ClientStore;
